import React from "react";
import Moment from 'moment';
import FilterDateProto from "../lib/date-field";

export default class FilterField2Date extends FilterDateProto {

    constructor(filtersManager, field, initValue) {
        super(filtersManager, field, initValue, field.label);

        // this.filterConfig is field2 object

        this.field = this.filterConfig.fieldId;
        this.isCustomField = this.filterConfig.isCustom;
        this.noDateLabel = 'Not set';
    }

    filterFunc(dataItem) {
        if (!this.value) return true;

        let value = dataItem[this.filterConfig.fieldId];
        if (value) value = Moment(value);

        // filter items without date set
        // + patch AR issue
        if (!this.value.noDate && (!value)) return false;

        // allow all without date set
        if (this.value.noDate && (!value)) return true;

        // prevent potential issue - here we should have date for sure...
        if (!this.value.date) return true;

        switch (this.value.curOption) {
            case 'is-before': return value.isBefore(this.value.date);
            case 'is-after': return value.isAfter(this.value.date);
            case 'range': return value.within(this.value.date);
            default: console.error("FilterField2Date: Unknown date filter value", this.value);
        }

        console.error("FilterField2Date: should not happen");

        return true;
    }

    filterFuncUniversal(dataItem) {return this.filterFunc(dataItem)}
}
